<template>
    <div class="chart"></div>
</template>

<script>
import Chart from 'chart.js'
import { chartData } from '@/plugins/chart.js'

export default {
    name: 'Chart',
    props: {
        idChart: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'bar'
        },
        labels: {
            type: Array,
            default: () => {
                return ['Jupiter', 'Saturn', 'Uranus', 'Neptune']
            }
        },
        datasets: {
            type: Array,
            default: () => [
                {
                    label: 'Planetary Mass (relative to the Sun x 10^-6)',
                    data: [954.792, 285.886, 43.662, 51.514],
                    backgroundColor: 'rgba(71, 183,132,.5)',
                    borderColor: '#47b784',
                    borderWidth: 3
                }
            ]
        }
    },
    data() {
        return {
            currentIdChart: '',
            barChartData: { ...chartData }
        }
    },
    mounted() {
        ;(async () => {
            this.currentIdChart = this.idChart + '-content'
            this.barChartData.type = this.type
            this.barChartData.data.labels = this.labels
            this.barChartData.data.datasets = this.datasets

            const canvas = document.createElement('canvas')
            canvas.id = this.currentIdChart
            document.querySelector(`#${this.idChart}`).append(canvas)

            const ctx = await document.querySelector(`#${this.currentIdChart}`)
            await new Chart(ctx, this.barChartData)
        })()
    }
}
</script>

<style scope src="./Chart-light-theme.css"></style>
<style scope src="./Chart-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/chart/Chart.vue